import { Injectable } from '@angular/core';
import { EntityService } from './entity.service';
import { JQueryHTTPClient } from './JQueryHTTPClient';
import { Rest } from './rest_client';

@Injectable()
export class VehicleversioncategoryService extends EntityService<Rest.VehicleVersionCategory>{
  client: Rest.RestApplicationClient;
  constructor(private jquery: JQueryHTTPClient) {
    super();
    this.client = new Rest.RestApplicationClient(jquery);
  }

  getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.VehicleVersionCategory>> {
    return this.client.VehicleVersionCategory_getPage(arg0);
  }

  getListByClient(clientId: number): Rest.RestResponse<Rest.VehicleVersionCategory[]> {
    return this.client.VehicleVersionCategory_getListByClient(clientId);
  }

  getEnabledListByClient(clientId: number): Rest.RestResponse<Rest.VehicleVersionCategory[]> {
    return this.client.VehicleVersionCategory_getEnabledListByClient(clientId);
  }

  create(arg0: Rest.VehicleVersionCategory): Rest.RestResponse<any> {
    return this.client.VehicleVersionCategory_create(arg0);
  }

  update(arg0: Rest.VehicleVersionCategory): Rest.RestResponse<Rest.VehicleVersionCategory> {
    return this.client.VehicleVersionCategory_update(arg0);
  }

  changeStatus(
    arg0: number[],
    queryParams?: { status?: boolean}
  ): Rest.RestResponse<void> {
    return this.client.VehicleVersionCategory_changeStatus(arg0, queryParams);
  }

  // @ts-ignore
  find(
    arg0: string,
    queryParams?: { id?: number }
  ): Rest.RestResponse<Rest.VehicleVersionCategory> {
    return this.client.VehicleVersionCategory_find(arg0, queryParams);
  }
}
